import { config } from '../config';
import { addAuthHeader } from './auth';

export async function sendAccessRequest() {
  const response = await fetch(
    `${config.backendUrl}/access-request`,
    {
      method: 'POST',
      headers: await addAuthHeader({ 'Content-Type': 'application/json' })
    })
  return await response.json();
}